import ConfigEntityNotFoundSvgComponent from "../../assets/svg-components/not-found/config-entity";
import { NavLink } from "react-router-dom";
import "./index.scss";

export default function ConfigEntityNotfound(props: any) {
  return (
    <>
      <div className="new-not-found-wrap">
        <div className="new-not-found-wrap__details config_vendors_not_found">
          {/* <img
            src="/images/page-not-found/config-entity.svg"
            className="not-found-image img-fluid not-found-image-config-vendors"
          /> */}
          <div className="not-found-image img-fluid not-found-image-config-vendors">
            <ConfigEntityNotFoundSvgComponent />
          </div>
          <p className="no-data-found-text no-data-found-text-config-vendors">
            Entity mapping is not configured. Please contact the Lexcare
            administrator to arrange for entity mapping configuration.
          </p>

          <div className="items cursor-pointer" onClick={props.handleModal}>
            <div className="list-managemnet-wrapper__form-add-icon btn btn-primary btn-add-no-record">
              <div className=" d-flex justify-content-center align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24"><path d="M11 19V13H5V11H11V5H13V11H19V13H13V19Z" fill="#ffffff"></path></svg>
                Add Entity Mapping
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
